import { render, staticRenderFns } from "./SelectTerminalsList.vue?vue&type=template&id=864411a8&"
import script from "./SelectTerminalsList.vue?vue&type=script&lang=js&"
export * from "./SelectTerminalsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports